export enum POAServiceProviderSource {
  StatementRecommendation = "statementRecommendation",
  GenericRecommendation = "genericRecommendation",
  Manual = "manual",
}
